import { render } from "./AdminHistoryNotesModal.vue?vue&type=template&id=2e0e8b2c"
import script from "./AdminHistoryNotesModal.vue?vue&type=script&lang=js"
export * from "./AdminHistoryNotesModal.vue?vue&type=script&lang=js"

import "./AdminHistoryNotesModal.vue?vue&type=style&index=0&id=2e0e8b2c&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__